import { createMutation, createSuspenseQuery, makeQueryKey } from "@steto-care/steto-query";

import { NotesRepository } from "@/io/repository/NotesRepository.ts";

export class NotesQueries {
  constructor(private readonly notes: NotesRepository = new NotesRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useNote = createSuspenseQuery(
    "note",
    ({ patientId }) => makeQueryKey(patientId),
    async (data: { patientId: string }) => this.notes.getNote(data.patientId),
  );

  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  useWriteNote = createMutation(
    "write-note",
    async (data: { patientId: string; note: string | undefined }) => this.notes.writeNote(data.patientId, data.note),
    {
      onSuccess: (_, { patientId }, { client }) => {
        this.useNote.invalidate(client, {
          patientId,
        });
      },
    },
  );
}
